const envConfig = require(`./config/${process.env.NODE_ENV}.json`);

interface ConfigState {
    environment: string;
    id_url: string;
    api_url: string;
    privapi_url: string;
    wl_url: string;
    lecab_url: string;
    webapp_rider_url: string;
    google_key: string;
    aws_url: string;
    lecab_geo: {
        url: string;
        key: string;
        code: string;
    };
}

export default envConfig as ConfigState;
